import React, { useState } from "react";
import { withRouter, Link } from "react-router-dom";
import * as Yup from "yup";
import { useFormik } from "formik";
import { postForgotPassword } from "../../helpers/fakebackend_helper";
import AuthShell from "./AuthShell";
import AuthField from "./AuthField";

const ForgotPassword = () => {
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: { email: "" },
    validationSchema: Yup.object({
      email: Yup.string().email("Please enter a valid email").required("Email is required"),
    }),
    onSubmit: async (values, { setSubmitting }) => {
      setError("");
      try {
        await postForgotPassword(values.email);
        setSubmitted(true);
      } catch (err) {
        setError(typeof err === "string" ? err : "Failed to send reset link.");
      } finally {
        setSubmitting(false);
      }
    },
  });

  document.title = "Forgot Password | BiorGov Admin";

  return (
    <AuthShell
      title="Forgot password"
      subtitle="Enter your email and we'll send you a reset link."
      footer={<Link to="/login" style={{ color: "var(--bl-accent-light)" }}>Back to sign in</Link>}
    >
      {submitted ? (
        <div className="alert alert-success">
          If an account exists for that email, a reset link has been sent. Check your inbox.
        </div>
      ) : (
        <>
          {error && <div className="alert alert-danger" style={{ marginBottom: "1rem" }}>{error}</div>}
          <form onSubmit={(e) => { e.preventDefault(); validation.handleSubmit(); }}>
            <AuthField
              label="Email"
              name="email"
              type="email"
              autoComplete="email"
              placeholder="you@biorgov.com"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.email || ""}
              error={validation.errors.email}
              touched={validation.touched.email}
            />
            <button type="submit" className="bl-btn-primary" style={{ width: "100%", padding: "0.7rem 1rem" }} disabled={validation.isSubmitting}>
              {validation.isSubmitting ? "Sending…" : "Send reset link"}
            </button>
          </form>
        </>
      )}
    </AuthShell>
  );
};

export default withRouter(ForgotPassword);
